import { useProtectedAuth } from '@/hooks/useAuth';
import { useTranslation } from '@/hooks/useTranslation';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';

export const SignOutPage = () => {
  const { t: translate } = useTranslation('common');
  const { signOut } = useProtectedAuth();
  const { state } = useLocation();
  const isLogout = state?.type === 'logout';
  useEffect(() => {
    if (isLogout) {
      signOut();
    }
  }, [state]);
  return (
    <div>
      <title>blank</title>
      {createPortal(
        isLogout && (
          <div className="fixed inset-0 z-[2147483647] grid place-items-center bg-surface-0">
            <div className="flex flex-col items-center gap-3">
              <div>
                <i className="pi pi-spinner pi-spin text-7xl"></i>
              </div>
              <div className="animate-textshimmer bg-[linear-gradient(135deg,_#ffffff,_#5E5E5E,_#ffffff)] bg-[length:200%_100%] bg-clip-text text-2xl text-transparent">
                {translate('signOutMsg')}
              </div>
            </div>
          </div>
        ),
        document.body,
      )}
    </div>
  );
};

export default SignOutPage;
